<template>
	<div>
		<h2>404 Page not found</h2>
	</div>
</template>

<script>

	export default {
		name: 'Error404',
		data() {
			return {
			} 
		},
	}
</script>

<style lang="scss" scoped>
	
</style>
